import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./blog.scss";
import { BLOG, BLOG_DETAIL } from "../../Routes/RouteConstent";
import { getBlogCardImage } from "../../Screens/Blog/blogImageUtils";

const BlogsBlock = ({ news }: any) => {
  const navigate = useNavigate();

  const blogPath = (item: any) => {
    if (item?.external_url) return item.external_url;
    if (item?.slug) return BLOG_DETAIL.replace(":slug", item.slug);
    return item?.url || BLOG;
  };

  const cardImage = getBlogCardImage;

  return (
    <section className="blog-section py-5">
      <div className="container">
        <div className="row mb-5">
          <div className="col-lg-12 col-md-12 text-center section-header">
            <h2 className="home-section-title p-0">
              Our <span className="strong">Blog</span>
            </h2>
          </div>
        </div>
        <div className="row">
          {Array.isArray(news) &&
            news.map((newsData: any) => {
              const to = blogPath(newsData);
              const isExternal = Boolean(newsData?.external_url);
              const Wrapper: any = isExternal ? "a" : Link;
              const wrapperProps = isExternal
                ? { href: to, target: "_blank", rel: "noreferrer" }
                : { to };

              return (
                <div
                  className="col-md-4 col-lg-4 d-flex"
                  key={newsData?.id || newsData?.slug || newsData?.title}
                >
                  <Wrapper {...wrapperProps} className="blog-card-link">
                    <article className="blog-card mx-0 mx-md-4 pb-3">
                      <div
                        className="blog-img"
                        style={{ backgroundImage: `url(${cardImage(newsData)})` }}
                        role="img"
                        aria-label={newsData?.title}
                      />
                      <div className="blog-content mt-2 mx-2 pb-4 border-bottom">
                        <span className="creation-date">{newsData?.days}</span>
                        <h6 className="my-2">{newsData?.title}</h6>
                        <p className="m-0 blog-summary">{newsData?.summary}</p>
                        <span className="read-more d-inline-block mt-2">Read More</span>
                      </div>
                    </article>
                  </Wrapper>
                </div>
              );
            })}
        </div>

        {Array.isArray(news) && news.length >= 3 && (
          <div className="row">
            <div className="col-lg-12 col-md-12 text-center ">
              <button
                type="button"
                className="w-auto primary-blue-btn px-5 my-4"
                onClick={() => navigate(BLOG)}
              >
                View All
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default BlogsBlock;
